import React, {Component } from 'react'
import firebase from './firebase'
import './IRISDownload.css'
import './eBook.css'
import featlogo from '../src/images/ebook-img/iris-feat-logo.png'
import downloadicon from '../src/images/ebook-img/download-icon.png'
import irisPlay from '../src/images/ebook-img/iris-play.png'  
import uipathFeatsystems from '../src/images/feat-uipath/featsystems-uipath.png'  
import irisImg from '../src/images/feat-uipath/iris-logo.png'  
import ogImage from '../src/images/feat-uipath/feat-uipath-irisi-og-img.jpg'  
import UserForm from './UserForm'

import { Helmet } from 'react-helmet';


export class IRISDownload extends Component {
  constructor(){
    super();
    this.state={
        Videolink:''
    }
    
  }
 
  handleShowHideVideo=()=>{
    //let Videolink='https://www.youtube.com/embed/AEKVwQXaVEQ?autoplay=1';
    this.setState({isShowVideo:true})
  }

  handleCloseVideo=()=>{
    //let Videolink='https://www.youtube.com/embed/AEKVwQXaVEQ?autoplay=1';
    this.setState({isShowVideo:false})
  }
  

  render(){
    
    let videoShowClass=this.state.isShowVideo ? 'displayVideo' : '';
    let PlabtnSHowClass=this.state.isShowVideo ? 'hidePlayBtn' : '';
    let videoLink=this.state.isShowVideo ? 'https://www.youtube.com/embed/AEKVwQXaVEQ?autoplay=1' : '';
    return(
            <>
            <div className="application">
                  <Helmet>
                      <meta charSet="utf-8" />
                      <title>IRIS eBook download | Featsystems</title>
                    
                      <meta name="description" content="Download your IRIS ebook and get to know in detail why IRIS is the only one-stop-shop solution for the entire process transformation." />
                      <link rel="canonical" href="https://irisebookdownload.featsystems.com/" />

                      <meta property="og:title" content="IRIS solution e-book Download | Featsystems " />
                      <meta property="og:image" content="https://www.featsystems.com/Content/images/og_img/iris-bot-og-img-new.jpg" />
                      <meta property="og:description" content="Download your IRIS ebook and get to know in detail why IRIS is the only one-stop-shop solution for the entire process transformation." />
                      <meta property="og:url" content="https://irisebookdownload.featsystems.com/" />
                  </Helmet>
                  ...
              </div>

            <div className="brand-page">
              <div className="iris-section">
                <div className="container">
                  <div className="row align-center">
                    <div className="col-6 col-sm-12">
                      <div className="iris-ft">
                        <a href=""><img className="img-fluid" src={uipathFeatsystems} /></a>
                      </div>
                    </div>
                    <div className="col-sm-12 col-6 text-right">
                      <img className="img-fluid" src={irisImg} />
                    </div>
                    <div className="col-6 col-sm-12">
                      <div className="modal-box active " id="registerModal">
                        <div className="iris-box">
                          <div>
                            
                            <UserForm/>
                            
                              
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-sm-12 text-right">
                      <div className={'iris-video active '+ videoShowClass}  >
                        <iframe className="responsive-v" id="ytVideo" src={videoLink} frameBorder={0} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen="allowfullscreen" />
                        <div className="ldcss">
                          <span className="waittxt">Please wait..</span>
                        </div>
                        <div className={'close-md cls-icon ' + videoShowClass} onClick={this.handleCloseVideo.bind()}>✖</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={'iris--play-box ' +PlabtnSHowClass} id="playVd" onClick={this.handleShowHideVideo.bind()}>
                <img src={irisPlay} className="img-fluid" />
              </div>
            {/* <div>
                <label></label>
                <div id='recaptcha'>
                </div>
                <button onClick={this.handleClick}>Click</button>
            </div> */}
        </div>
        </>  
    
    )
  }
}

export default IRISDownload

